import { Container as BSContainer } from "react-bootstrap";
import styled from "styled-components";
import CustomSearchInput from "../../components/CustomSearchInput";

export const Container = styled(BSContainer)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 0;

  td:nth-child(1) {
    width: 320px;
  }

  td:last-child {
    width: 25px;
  }

  th {
    text-transform: uppercase;
  }

  .more-icon {
    height: 15px;
  }
`;

export const ActionButton = styled.button`
  height: 32px;
  width: 32px;
  color: #6c757d;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  border-width: 0;
  background-color: transparent;

  &:hover {
    color: #000000;
    transition: color 0.3s ease;
  }
`;

export const SearchGroup = styled.div`
  display: flex;

  svg {
    width: 15px;
  }
`;

export const SearchInput = styled(CustomSearchInput)``;

export const AbsoluteLeft = styled.div`
  position: absolute;
  bottom: 0;
  align-self: flex-start;
`;

export const AbsoluteRight = styled.div`
  position: absolute;
  bottom: 0;
  align-self: flex-end;
`;
